import { render, staticRenderFns } from "./TEGdetail.vue?vue&type=template&id=446db6c0&scoped=true"
import script from "./TEGdetail.vue?vue&type=script&lang=js"
export * from "./TEGdetail.vue?vue&type=script&lang=js"
import style0 from "./TEGdetail.vue?vue&type=style&index=0&id=446db6c0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "446db6c0",
  null
  
)

export default component.exports